import React from "react";
import "./HouseingTransform.css";

const EngineeringTechnicalTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Keep Your Building Systems Running Smoothly
        </h2>
        <p className="workplace-cta-text">
          Get expert technical maintenance to ensure reliable operations and extend the life of your building assets
        </p>

        <a href="#contact" className="workplace-cta-btn">
         Book a Technical Maintenance Audit →
        </a>
      </div>
    </section>
  );
};

export default EngineeringTechnicalTransform;
